export namespace MESSAGES {
  export const LOGIN_FORM: string = "Login";
  export const VALIDATE_ADMISSION_FORM: string = "Verify your admission details.";
  export const LOGOUT: string = "You have successfully logged out. Thank you for using our service!";
  export const SESSION_EXPIRED: string = "Your login session has expired. Please log in again to continue.";
  export const ENQUIRY_FORM_HEADING = "We’re Here to Help – Send Your Query.";
  export const ADMISSIONS_FORM_HEADING =
    "Admission to Naasih Public School follows a simple two-step process. First, you must submit an enquiry form, then your child must  appear for entrance exam. If eligible, you will proceed to the next step by submitting the admission form and paying the admission fee. Your child's admission process will then be completed.";
  export const ADMISSION_FORM_SUBMITTED =
    "Thank you for submitting your admission request. Please reach out to the school for the next steps in the process.";
  export const STD_EQUIRY_FORM_HEADING =
    "Thank you for reaching out! Kindly complete this form, and we will get in touch with you shortly with more details.";

  //Enquiries
  export const ENQUIRY_SUBMIT_SUCCESFUL =
    "Thank you for your enquiry. Please reach out to the school office to proceed further with the admission process.";
  export const FORGOT_LOGIN_ID = "Retrieve Login Id";
}

export namespace IndexComponentConstants {
  export const WELCOME_VIEW = "WELCOME_VIEW";
  export const ADMISSION_VIEW = "ADMISSION_VIEW";
  export const LOGIN_VIEW = "LOGIN_VIEW";
  export const ENQUIRY_VIEW = "ENQUIRY_VIEW";
  export const ID_CARD_FORM_VIEW = "ID_CARD_FORM_VIEW";
}

export namespace STUDENT_MESSAGES {
  export const UPDATED = "The student has been updated successfully.";
  export const CREATED = "The student has been created successfully.";
  export const ACTIVATE_PART1 =
    "You are about to activate the var_student_name in the system and generate Fee Dues for the grade var_grade_name. " +
    "If the grade is incorrect, please update the student's details before proceeding. ";
  export const ACTIVATE_PART1_V2 =
    "You are about to activate var_student_name in the system. The system will not generate fee dues for Grade var_grade_name if they already exist. If no dues exist, the system will create them automatically." +
    "If the grade is incorrect, please update the student's details before proceeding. ";
  export const ACTIVATE_PART2 =
    "Please print the admission form before activating the student. Once the student is activated, printing will not be possible at this time due to current system limitations. ";
  export const ACTIVATE_PART3 = "Would you like to continue?";
  export const DASHBOARD_WELCOME_MSG1 = "Welcome to Your School App!";
  export const DASHBOARD_WELCOME_MSG2 =
    "We're so glad you're here! Whether you're checking in for assignments, staying up-to-date with events, or connecting with your teachers and classmates, this app is your gateway to all the exciting things happening at school.";
}

export namespace PAYMENT_MESSAGES {
  export const PLEASE_COMPLETE_PAYMENT = "Please wait as the app will periodically check the payment status.";
  export const PAYMENT_IN_PROGRESS =
    "You cancelled the payment, but it has already been initiated. You can either complete the payment or wait for 15 minutes for it to expire.";
}

export const LIST_STUDENT_VIEW = {
  GRADE_SECTION_MESSAGE: "Filter Student",
};

export const MODIFY_STUDENT_VIEW = {
  GRADE_SECTION_MESSAGE: "Retrieve students for editing",
};

export const PROMOTE_STUDENT_VIEW = {
  GRADE_SECTION_MESSAGE: "Fetch Students to Promote",
};
